// Test IDs for the Choice Ayurveda site. Naming: <feature>-<element> in kebab-case.
export const SITE = {
    // Global
    ghlEmbedWrapper: "ghl-embed-wrapper",
    ghlEmbedLabel: "ghl-embed-label",
    ghlEmbedPasteArea: "ghl-embed-paste-area",
    siteFooter: "site-footer",
    footerQuickLinks: "footer-quick-links",
    footerSocialLinks: "footer-social-links",
    footerLogo: "footer-logo",
    devNavStrip: "dev-nav-strip",
    devNavLink: "dev-nav-link",

    // Buttons / CTAs
    primaryButton: "primary-button",
    secondaryButton: "secondary-button",
    bookConsultationCta: "book-consultation-cta",

    // Home
    homeHero: "home-hero",
    homeIntro: "home-intro",
    homePillars: "home-pillars",
    homeTreatmentsPreview: "home-treatments-preview",
    homePackagesPreview: "home-packages-preview",
    homePractitioner: "home-practitioner",
    homeBlogPreview: "home-blog-preview",
    homeTestimonials: "home-testimonials",
    homeShopTeaser: "home-shop-teaser",
    homeContactCta: "home-contact-cta",

    // Treatments
    treatmentsGrid: "treatments-grid",
    treatmentCard: "treatment-card",
    treatmentExpand: "treatment-expand-button",

    // Packages
    pricingSection: "pricing-section",
    pricingPlan: "pricing-plan-card",
    pricingCta: "pricing-cta-button",

    // Education
    pillarCard: "pillar-card",
    elementCard: "element-card",
    doshaCard: "dosha-card",

    // Blog
    blogCard: "blog-card",
    blogReadMore: "blog-read-more-link",
    blogPostTitle: "blog-post-title",
    blogSearchInput: "blog-search-input",

    // FAQ
    faqAccordion: "faq-accordion",
    faqItem: "faq-item",

    // Testimonials
    testimonialsCarousel: "testimonials-carousel",
    testimonialCard: "testimonial-card",

    // Shop teaser
    shopTeaserBanner: "shop-teaser-banner",
    shopTeaserCta: "shop-teaser-cta",

    // Contact
    contactDetails: "contact-details",
    contactMap: "contact-map-placeholder",
    contactGhlForm: "contact-ghl-form",
};
